export const superAdmin = '0x45Aba376709211a628964831bE78499D9931807E'
export const developerAddr = '0x892607bEF2b3c5d70917ee57FD1Ae55f38A63873'
export const chainId = '0x19'       // cronos  '0x19'  sepolia '11155111
export const checkAdmin = (useraddr) => {
    console.log("useraddr:", useraddr)
    if (useraddr == superAdmin.toLowerCase()) {
        return true
    }
    else if (useraddr == developerAddr.toLowerCase()) {
        return true
    }
    else {
        return false
    }
}